export default __webpack_public_path__ + "static/media/coldsnap.0cccf52d.mpeg";